import { render } from "./OrdersTab.vue?vue&type=template&id=606f0ce0&scoped=true"
import script from "./OrdersTab.vue?vue&type=script&lang=js"
export * from "./OrdersTab.vue?vue&type=script&lang=js"

import "./OrdersTab.vue?vue&type=style&index=0&id=606f0ce0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606f0ce0"]])

export default __exports__